import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";
import config from "../../config/api";
const BackendURL = `${config.backendUrl}/notify`;

// 🔹 Get all notifications (paginated, optional unread filter)
export const fetchNotifications = createAsyncThunk(
    "notifications/fetchAll",
    async ({ page = 1 ,unread = false }, { rejectWithValue, getState }) => {
        try {
            const token = getState().auth?.token; // assuming auth slice stores JWT
            const res = await axiosInstance.get(`${BackendURL}?page=${page}&unread=${unread}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            return res.data; 
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

// 🔹 Mark single notification as read
export const markNotificationRead = createAsyncThunk(
    "notifications/markRead",
    async (id, { rejectWithValue, getState }) => {
        try {
            const token = getState().auth?.token;
            const res = await axiosInstance.post(`${BackendURL}/${id}/read`, {}, {
                headers: { Authorization: `Bearer ${token}` },
            });
            return res.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

// 🔹 Mark all notifications as read
export const markAllNotificationsRead = createAsyncThunk(
    "notifications/markAllRead",
    async (_, { rejectWithValue, getState }) => {
        try {
            const token = getState().auth?.token;
            const res = await axiosInstance.post(`${BackendURL}/read-all`, {}, {
                headers: { Authorization: `Bearer ${token}` },
            });
            return res.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

// ====================
// Slice
// ====================

// const notificationSlice = createSlice({
//     name: "notifications",
//     initialState: {
//         notifications: [],
//         unreadCount: 0,
//         loading: false,
//         error: null,
//         page: 1,
//         hasMore: true,
//     },
//     reducers: {
//         clearNotifications: (state) => {
//             state.notifications = [];
//             state.unreadCount = 0;
//             state.page = 1;
//         },
//         receiveNotification: (state, action) => {
//             // add to top of list
//             state.notifications = [action.payload, ...state.notifications];
//             state.unreadCount = (state.unreadCount || 0) + (action.payload.isRead ? 0 : 1);
//         },
//         // optionally markLocalRead if you want optimistic UI
//         markLocalRead: (state, action) => {
//             const id = action.payload;
//             state.notifications = state.notifications.map(n => n._id === id ? { ...n, isRead: true, readAt: new Date().toISOString() } : n);
//             state.unreadCount = Math.max(0, state.unreadCount - 1);
//         }
//     },
//     extraReducers: (builder) => {
//     },
// });
const notificationSlice = createSlice({
    name: "notifications",
    initialState: {
        notifications: [],
        unreadCount: 0,
        loading: false,
        error: null,
        page: 1,
        hasMore: true,
    },
    reducers: {
        clearNotifications: (state) => {
            state.notifications = [];
            state.unreadCount = 0;
            state.page = 1;
        },
        receiveNotification: (state, action) => {
            state.notifications = [action.payload, ...state.notifications];
            state.unreadCount += action.payload.isRead ? 0 : 1;
        },
        markLocalRead: (state, action) => {
            const id = action.payload;
            state.notifications = state.notifications.map((n) =>
                n._id === id ? { ...n, isRead: true, readAt: new Date().toISOString() } : n
            );
            state.unreadCount = Math.max(0, state.unreadCount - 1);
        },
    },

    extraReducers: (builder) => {
        // 🔹 FETCH
        builder
            .addCase(fetchNotifications.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchNotifications.fulfilled, (state, action) => {
                state.loading = false;
                state.notifications = action.payload.notifications || [];
                state.unreadCount = action.payload.unreadCount || 0;
                state.error = null;
            })
            .addCase(fetchNotifications.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            });

        // 🔹 MARK SINGLE READ
        builder
            .addCase(markNotificationRead.fulfilled, (state, action) => {
                const updated = action.payload;
                const index = state.notifications.findIndex((n) => n._id === updated._id);
                if (index !== -1) state.notifications[index] = updated;
                state.unreadCount = Math.max(0, state.unreadCount - 1);
            });

        // 🔹 MARK ALL READ
        builder
            .addCase(markAllNotificationsRead.fulfilled, (state) => {
                state.notifications = state.notifications.map((n) => ({
                    ...n,
                    isRead: true,
                    readAt: new Date().toISOString(),
                }));
                state.unreadCount = 0;
            });
    },
});

export const { clearNotifications, receiveNotification, markLocalRead } = notificationSlice.actions;
export default notificationSlice.reducer;